import React, { useState, useEffect, useCallback, useReducer } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { dispensingModuleManager, moduleManager } from 'redux/action/modules';
import ModuleSearchBar from '../moduleSearchBar/ModuleSearchBar';
import paramSetterReducer from 'utils/customReducer/paramSetterReducer';
import Table from 'utils/table/Table';
import { Styles } from 'utils/table/Table.css.js';

import { columnSetter } from './columns';
import { makeDataLevel } from './makeDataLevel';
import { customAxiosGetFunction, customAxiosPostFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';

const ModuleDetailTable = () => {
  const history = useHistory();
  const dispatchs = useDispatch();
  const user = useSelector((store) => store.loginManager.status);
  const [moduleType, setModuleType] = useState('');
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState(columnSetter(moduleType, user.authLevel));
  const [paramState, dispatch] = useReducer(paramSetterReducer, {
    pageIndex: 0,
    pageCount: 0,
    pageSize: 25,
    elementCount: 0,
    canNextPage: false,
    canPreviousPage: false,
  });

  const setTableData = useCallback(async () => {
    customAxiosGetFunction(history, '/api/module/getDataTable', {
      params: { ...paramState, moduleType: moduleType, authIdx: user.authIdx },
    }).then((response) => {
      if (nvl(response, null) === null) {
        return false;
      }

      const sortedContent = nvl(response.content, []).sort((a, b) => {
        return a.moduleIdx - b.moduleIdx;
      });
  
      dispatch({ type: 'CHANGE_TOTAL', pageCount: response.totalPages, elementCount: response.totalElements });
      dispatch({ type: 'CHANGE_CANPAGE', canNextPage: !response.last, canPreviousPage: !response.first });
  
      setData(
        sortedContent.map((d, index) => {
          return {
            ...makeDataLevel(d, paramState.pageIndex, paramState.pageSize, index),
          };
        })
      );
    });
  }, [paramState, moduleType, history]);

  const moduleCalibrateCompletion = useCallback(async (moduleIdx) => {
    customAxiosPostFunction(history, '/api/module/calibrate', { moduleIdx })
      .then((response) => {
        if (response !== null) {
          dispatchs(dispensingModuleManager(Number(user.authIdx)));
          dispatchs(moduleManager(Number(user.authIdx)));
          alert(`교정완료`);
          window.location.reload(false);
        } else {
          alert(`교정실패`);
        }
      })
      .catch(function (error) {
        alert(`교정실패`);
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setTableData();
    setColumns(columnSetter(moduleType, user.authLevel, moduleCalibrateCompletion, setTableData));
  }, [paramState.pageIndex, moduleType]);

  return (
    <>
      <ModuleSearchBar setTableData={setTableData} setModuleType={setModuleType} />
      <Styles>
        <Table columns={columns} data={data} setParamDispatch={dispatch} {...paramState} />
      </Styles>
    </>
  );
};

export default ModuleDetailTable;
